import {useEffect, useRef} from "react";
import {
    ANALYTICS_EVENTS,
    trackAnalyticsEvent,
} from "../../../../../analytics";

export const useOnSuccess = ({
    success,
    id,
                                 imagesUploaded,
                                 layoutUploaded,
                                 returnedContractId,
                                 imagesSuccess,
                                 layoutSuccess
                             }) => {
    const trackedSuccessKeyRef = useRef<string | null>(null);

    useEffect(() => {
        if (success && id && imagesUploaded && layoutUploaded) {
            const trackingKey = `updated:${id}`;
            if (trackedSuccessKeyRef.current !== trackingKey) {
                trackedSuccessKeyRef.current = trackingKey;
                trackAnalyticsEvent(ANALYTICS_EVENTS.ASSIGNMENT_UPDATED, {
                    assignment_id: id,
                    images_uploaded: Boolean(imagesUploaded),
                    layout_uploaded: Boolean(layoutUploaded),
                });
            }
            window.location.href = `/contract-assignment/${id}`;
        }
        if (success && !id && returnedContractId) {
            const trackingKey = `created:${returnedContractId}`;
            if (trackedSuccessKeyRef.current !== trackingKey) {
                trackedSuccessKeyRef.current = trackingKey;
                trackAnalyticsEvent(ANALYTICS_EVENTS.ASSIGNMENT_CREATED, {
                    assignment_id: returnedContractId,
                    images_uploaded: Boolean(imagesUploaded),
                    layout_uploaded: Boolean(layoutUploaded),
                });
            }
            window.location.href = `/contract-assignment/${returnedContractId}`;
        }
    }, [success, imagesSuccess, layoutSuccess]);
}
